import { isNotEmpty } from "./isNotEmpty";

export const transformCommaSeparatedStringToArray = (str: string) =>
  str
    .split(",")
    .filter(isNotEmpty)
    .map((item) => item.trim());
